"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireWildcard(require("react"));
var _services = require("../../../../services");
var _EntelCharacteristicsTab = _interopRequireDefault(require("./EntelCharacteristicsTab"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const BorderContainer = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  border-radius: 12px;
  border: 1px solid var(--New-palette-Default-Monochrome-Monochrome3, #bebebe);
  border-bottom: none;
  background: #fff;
  & > div > div:last-child {
    border-bottom: none;
    & > div:last-child {
      border-bottom-right-radius: 12px;
      border-bottom-left-radius: 12px;
    }
  }
`;
const EntelTopFeatures = _ref => {
  let {
    handset,
    handsetIndex
  } = _ref;
  const [isDisplayed, setIsDisplayed] = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 6,
      bottom: 4
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.SimpleGrid, {
    justify: 'center'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.LinkWithIcon, {
    id: `recommendation-handset-button-full-specs-${handsetIndex}`,
    appearance: 'secondary',
    text: _services.Services.locale.localeString('Recommendation.ShowFullSpecs'),
    icon: {
      name: 'list-view',
      justify: 'left'
    },
    fullSize: true,
    size: 3,
    onClick: () => setIsDisplayed(isDisplayed => !isDisplayed),
    dataAttributes: {
      'data-test-id': `characteristics-btn-${handsetIndex}`
    }
  }))), isDisplayed && /*#__PURE__*/_react.default.createElement(BorderContainer, null, /*#__PURE__*/_react.default.createElement(_EntelCharacteristicsTab.default, {
    handset: handset,
    handsetIndex: handsetIndex
  })));
};
var _default = EntelTopFeatures;
exports.default = _default;